/**
 * Attach a warn-only catch to whatever Mixpanel's `pause_session_recording()` /
 * `resume_session_recording()` returned.
 *
 * Those calls return the recorder's stop/flush promise. Its IndexedDB queue
 * (`mixpanelBrowserDb`) can reject with WebKit's "Database deleted by request
 * of the user" when the customer clears site data — or Safari evicts storage —
 * mid-session, and mixpanel's `RequestQueue.clear` has no catch of its own.
 * Left floating, that rejection reaches `GlobalErrorListener`, which toasts
 * "An unexpected error occurred" on a page that is working (Sentry
 * CUSTOMER-UI-7J, 2026-09-17). A browser tearing down its own storage is not
 * a failure of ours: log it for the replay console and move on.
 *
 * `Promise.resolve(result)` adopts a promise (marking a rejection handled) and
 * is inert for `undefined`/non-promise values, so the helper is safe whatever
 * the SDK's typings say the call returns.
 */
export function swallowRecorderTeardown(result: unknown): void {
  void Promise.resolve(result).catch((error: unknown) => {
    console.warn(
      "[analytics] Session recording pause/resume rejected (browser storage teardown)",
      error
    );
  });
}
